module.exports = __webpack_public_path__ + "img/home.2887c1b7.svg";